<template>
  <div class="mapbox">
    <div class="china-map" id="chinacourt-map">
      <svg ref="mapdom" height="550" version="1.1" width="635" style="overflow: hidden; position: relative; left: -0.5px;">
        <path v-for="(item, index) in mapArrD" :fill="item.color" stroke="#a7b7db" :d="item.d" stroke-width="1.5" stroke-linejoin="round" opacity="1" style="-webkit-tap-highlight-color: rgba(0, 0, 0, 0); cursor: pointer; stroke-linejoin: round; opacity: 1;" @click="getLink(item, index)"></path>
        <text @click="getLink(item, index)" v-for="(item, index) in mapArrD" :key="index" :x="item.x" :y="item.y" text-anchor="start" font="12px 宋体 Arial" stroke="none" fill="#000000" style="-webkit-tap-highlight-color: rgba(0, 0, 0, 0); text-anchor: start; font: 12px &quot;宋体 Arial&quot;; opacity: 1; cursor: pointer;" opacity="1">
          <tspan dy="5" style="-webkit-tap-highlight-color: rgba(0, 0, 0, 0);">{{item.name}}</tspan>
        </text>
      </svg>
      <div class="showbox" :style="pos" :class="{show:show}">
        <ul>
          <li class="showbox-list"><a href="javascript:;">新疆维吾尔自治区</a></li>
          <li class="showbox-list"><a href="javascript:;">新疆维吾尔自治区</a></li>
        </ul>
      </div>
      </div>
  </div>
</template>

<script>
import mapList from "../../mapArr";
console.log(mapList)
import { mapGetters, mapActions } from "vuex";
export default {
  components: {},
  name: "model",
  data() {
    return {
      message: "Hello Vue!",
      pos: {
        left: "-88px",
        top: 0
      },
      mapArrD: mapList,
      show: false
    };
  },
  methods: {
    ...mapActions([]),
    setpos: function(x, y) {
      console.log(x + "," + y);
      let inerY = parseInt(y) - 80;
      this.pos = {
        left: x + "px",
        top: inerY + "px"
      };
    },
    clickmap: function(e) {
      this.setpos(e.clientX, e.clientY);
    },
    getLink: function (item, index) {
      console.log(123)
      this.show = true
      let newArr = this.mapArrD;
      let len = newArr.length;
      let x = item.x;
      let y = item.y;
      for (let i = 0; i <len; i++) {
        newArr[i].color = '#e1efff'
      }
      newArr[index].color = '#5276fb';
      this.mapArrD = newArr;
      this.setpos(x, y)
    }
  },
  watch: {},
  computed: {
    ...mapGetters([])
  },
  created() {
  
  },
  mounted() {
    
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" rel="stylesheet/scss">
@import "../assets/scss/variables";
@import "../assets/scss/mixins";
.showbox {
  position: absolute;
  display: none;
  width: 176px;
  padding: 10px 0;
  border: 2px solid #bdbdbd;
  font-size: 16px;
  line-height: 36px;
  text-align: center;
  border-radius: 4px;
  background-color: #fff;
  a {
    color: $gray-base;
    &:hover {
      color: $a-hover;
    }
  }
}
.show {
  display: block;
}
.showbox::before {
  position: absolute;
  bottom: -32px;
  right: 80px;
  width: 0;
  height: 0;
  content: "";
  box-sizing: border-box;
  border: 16px solid transparent;
  border-top-color: #bdbdbd;
}
.showbox::after {
  position: absolute;
  bottom: -26px;
  right: 83px;
  width: 0;
  height: 0;
  content: "";
  box-sizing: border-box;
  border: 13px solid transparent;
  border-top-color: #fff;
}
.mapbox {
  position: relative;
  width: 100%;
  height: 100%;
}
.china-map {
  padding: 45px 45px 45px 105px; 
}
</style>